export default __webpack_public_path__ + "static/media/firefly2.c2813bff.gif";